import React, { useEffect, useState, createContext, useContext } from 'react';
interface PricingData {
  oldPrice: string;
  newPrice: string;
  savings: string;
  bonusPrice: string;
}
interface GeoPricingContextType {
  pricing: PricingData;
  isLoading: boolean;
}
const defaultPricing: PricingData = {
  oldPrice: '€25.99',
  newPrice: '€12.99',
  savings: 'AHORRAS €13.00',
  bonusPrice: '€6.50'
};
const pricingByCountry: Record<string, PricingData> = {
  AR: {
    oldPrice: 'ARS 44,267.99',
    newPrice: 'ARS 22,125.99',
    savings: 'AHORRAS ARS 22,142.00',
    bonusPrice: 'ARS 9.999'
  },
  CL: {
    oldPrice: 'CLP 28,641.99',
    newPrice: 'CLP 14,315.99',
    savings: 'AHORRAS CLP 14,326.00',
    bonusPrice: 'CLP 7,300'
  },
  CO: {
    oldPrice: 'COP 116,980.99',
    newPrice: 'COP 58,470.99',
    savings: 'AHORRAS COP 58,510.00',
    bonusPrice: 'COP 30,500'
  },
  PE: {
    oldPrice: 'S/ 104.99 PEN',
    newPrice: 'S/ 51.99 PEN',
    savings: 'AHORRAS S/ 53.00',
    bonusPrice: 'S/ 27.00'
  },
  EU: {
    oldPrice: '€25.99',
    newPrice: '€12.99',
    savings: 'AHORRAS €13.00',
    bonusPrice: '€6.50'
  },
  US: {
    oldPrice: '€25.99',
    newPrice: '€12.99',
    savings: 'AHORRAS €13.00',
    bonusPrice: '€6.50'
  },
  MX: {
    oldPrice: 'MXN 551.99',
    newPrice: 'MXN 275.99',
    savings: 'AHORRAS MXN 276.00',
    bonusPrice: 'MXN 140.00'
  },
  UY: {
    oldPrice: 'UYU 1,196.99',
    newPrice: 'UYU 597.99',
    savings: 'AHORRAS UYU 599.00',
    bonusPrice: 'UYU 300.00'
  },
  ES: {
    oldPrice: '€25.99',
    newPrice: '€12.99',
    savings: 'AHORRAS €13.00',
    bonusPrice: '€6.50'
  },
  DEFAULT: defaultPricing
};
const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
const GeoPricingContext = createContext<GeoPricingContextType>({
  pricing: defaultPricing,
  isLoading: true
});
export function GeoPricingProvider({
  children
}: {
  children: ReactNode;
}) {
  const [pricing, setPricing] = useState<PricingData>(defaultPricing);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await fetch('https://get.geojs.io/v1/ip/country.json');
        const data = await response.json();
        const countryCode = data.country.toUpperCase();
        let selectedPricing = pricingByCountry[countryCode] || pricingByCountry['DEFAULT'];
        if (euCountries.includes(countryCode)) {
          selectedPricing = pricingByCountry['EU'];
        }
        setPricing(selectedPricing);
      } catch (error) {
        console.error('Failed to fetch geo pricing, falling back to default:', error);
        setPricing(pricingByCountry['DEFAULT']);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCountry();
  }, []);
  return <GeoPricingContext.Provider value={{
    pricing,
    isLoading
  }} data-id="element-270">
      {children}
    </GeoPricingContext.Provider>;
}
export function useGeoPricing() {
  return useContext(GeoPricingContext);
}